import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = {
  id: "wrapper",
  class: "col-12"
}
const _hoisted_3 = { id: "header" }
const _hoisted_4 = { id: "body" }
const _hoisted_5 = { id: "footer" }

import { onMounted } from 'vue'
import TheHeader from './components/header/TheHeader.vue'
import TheFooter from './components/footer/TheFooter.vue'
import MainAll from './components/main/MainAll.vue'
import { initResize } from './model/util/dom/domResize'

// onMountedの登録

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  // 初期高さの設定
  initResize()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TheHeader, { "data-test": "header" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(MainAll, { "data-test": "main" })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TheFooter, { "data-test": "footer" })
      ])
    ])
  ]))
}
}

})